<template>
  <div class="booking-address booking-step js-booking-step" v-show="this.$options._componentTag === this.getCurrentStep" :id="this.$options._componentTag">
    <!-- INTERNET EXPLORER POPUP -->
    <div class="internet-explorer-popup">
      <span class="internet-explorer-popup-title">
            Booking does not support the browser you are using.<br>
            To use it, please switch to a supported browser!
      </span>
      <a class="btn ie-btn" href="/" rel="home">
        Back to Homepage
      </a>
    </div>
    <!-- .INTERNET EXPLORER POPUP -->
    <h1 class="booking-title">Address & Contact</h1>
    <div class="booking-steps__wrap">
      <div class="booking-location__form-holder">
        <form class="booking-location__form">
          <div class="booking-location__form-wrap-full">
            <div class="booking-location__form-wrap-fuller">
              <label for="booking-address" class="booking-label">Address <span>*</span></label>
              <div class="booking-location__form-input">
                <input class="booking-input js-booking-input js-location-search-vue" name="full_address" id="booking-address" required @input="getData();" :value="address ? address.full_address : ''" data-index="0" type="text" data-codes="" placeholder=" ">
                <!--<input type="hidden" id="address2">-->
                <!--<input type="hidden" id="postal_code">-->
                <!--<input type="hidden" id="locality">-->
                <!--<input type="hidden" id="state">-->
                <!--<input type="hidden" id="country">-->
                <input type="hidden" class="js-pu-re-trigger">
                <!-- <?php echo fws()->render()->inlineSVG('ico-close', 'booking-location__form-input-ico'); ?> -->
              </div>
            </div>
          </div>
          <div class="booking-location__form-wrap-half">
            <label for="address2" class="booking-label">Apartment <span>*</span></label>
            <div class="booking-location__form-input">
              <input class="booking-input js-booking-input address2" id="address2" type="text" name="apartment" required @input="getData();updateApartment($event.currentTarget);" :value="address ? address.apartment : ''">
            </div>
          </div>
          <div class="booking-location__form-wrap-half">
            <label for="locality" class="booking-label">Town/City <span>*</span></label>
            <div class="booking-location__form-input">
              <input :class="['booking-input js-booking-input']" id="locality" type="text" name="locality" required @input="getData()" :value="address ? address.locality : ''">
            </div>
          </div>
          <div class="booking-location__form-wrap-half">
            <label for="administrative_area_level_1" class="booking-label">State <span>*</span></label>
            <div class="booking-location__form-input">
              <input :class="['booking-input js-booking-input']" id="administrative_area_level_1" name="administrative_area_level_1" required type="text" @input="getData()" :value="address ? address.administrative_area_level_1 : ''">
            </div>
          </div>
          <div class="booking-location__form-wrap-half">
            <label for="postal_code" class="booking-label">Zip <span>*</span></label>
            <div class="booking-location__form-input">
              <input :class="['booking-input js-booking-input postal_code']" id="postal_code" type="number" name="postal_code" required @keyup="setZip($event.currentTarget)" @input="getData()" :value="address ? address.postal_code : ''">
            </div>
          </div>
        </form>
      </div>
      <!-- <div class="booking-side__image booking-location__image">
        <img class="media-item booking-side__image-firefox" :src="imagesPath" alt="animation">
        <div class="anim-holder">
          <div class="anim-container anim-container--01" ref="animContainer"></div>
        </div>
      </div> -->
    </div>
    <!--<div class="booking-steps__wrap-block">-->
    <!--  <div class="booking-address__form-wrap-half">-->
    <!--    <label for="booking-address" class="booking-label">Address <span>*</span></label>-->
    <!--    <div class="booking-address__form-input">-->
    <!--      <input class="booking-input" ref="addAddress" id="booking-address" :value="address" type="text" disabled>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--  <div class="booking-address__form-wrap-half booking-address__form-wrap-half&#45;&#45;small">-->
    <!--    <label for="booking-apartment" class="booking-label">Apartment <span>*</span></label>-->
    <!--    <div class="booking-address__form-input">-->
    <!--      <input class="booking-input" ref="addApartment" id="booking-apartment" :value="apartment" type="text" disabled>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
    <!--<a href="javascript:" class="checkbox-link" @click="goToFirstStep">Edit address and apartment number</a>-->
    <div class="booking-steps__wrap-upper-btns-block">
      <label for="booking-address" class="booking-label">How do we get in? <span>*</span></label>
      <span class="val-error js-date-error">Select one option</span>
      <div class="booking-steps__wrap-upper-btns">
        <div class="booking-steps__wrap-upper-btns-wrap">
          <a class="booking-steps__btn js-booking-steps__btn-first-row" data-name="home" @click="activeBtnFirstRow($event.currentTarget)" href="javascript:;">Someone
            is Home</a>
        </div>
        <div class="booking-steps__wrap-upper-btns-wrap">
          <a class="booking-steps__btn js-booking-steps__btn-first-row" data-name="doorman" @click="activeBtnFirstRow($event.currentTarget)" href="javascript:;">Doorman</a>
        </div>
        <div class="booking-steps__wrap-upper-btns-wrap">
          <a class="booking-steps__btn js-booking-steps__btn-first-row" data-name="key" :class="{ 'is-active':  contentVisibleThird}" ref="accBtn" href="javascript:;" @click="activeBtnFirstRow($event.currentTarget);showDropdownThird();">Hidden
            Key</a>
        </div>
        <div class="booking-steps__wrap-upper-btns-wrap">
          <a class="booking-steps__btn js-booking-steps__btn-first-row" data-name="other" :class="{ 'is-active':  contentVisible}" ref="accBtn" href="javascript:;" @click="activeBtnFirstRow($event.currentTarget);showDropdown();">Other</a>
        </div>
      </div>
      <div class="booking-steps__wrap-upper-btns-block-hidden" v-if="contentVisible">
        <span class="val-error js-date-error-textarea-owgi">This field is required</span>
        <label for="booking-address-textarea" class="booking-label">Other ways of getting in <span>*</span></label>
        <textarea id="booking-address-textarea" @keyup="addressInfo.getInMessageOther.innerText = $event.target.value" :value="addressInfo ? addressInfo.getInMessageOther.innerText : ''" class="booking-steps__textarea js-first-row-message-other" placeholder="Write..."></textarea>
      </div>
      <div class="booking-steps__wrap-upper-btns-block-hidden" v-if="contentVisibleThird">
        <span class="val-error js-date-error-textarea-key">This field is required</span>
        <label for="booking-address-textarea" class="booking-label">Hidden key is in <span>*</span></label>
        <textarea id="booking-address-textarea" @keyup="addressInfo.getInMessageKey.innerText = $event.target.value" :value="addressInfo ? addressInfo.getInMessageKey.innerText : ''" class="booking-steps__textarea js-first-row-message-key" placeholder="Write..."></textarea>
      </div>
    </div>
    <div class="booking-steps__wrap-upper-btns-block" id="app">
      <label for="booking-address" class="booking-label">Do you have pets? <span>*</span></label>
      <span class="val-error js-date-error">Select one option</span>
      <div class="booking-steps__wrap-upper-btns">
        <div class="booking-steps__wrap-upper-btns-wrap">
          <a class="booking-steps__btn js-booking-steps__btn-second-row" data-name="no-pets" href="javascript:;" @click="activeBtnSecondRow($event.currentTarget)">No
            Pets</a>
        </div>
        <div class="booking-steps__wrap-upper-btns-wrap">
          <a class="booking-steps__btn js-booking-steps__btn-second-row" data-name="cat" href="javascript:;" @click="activeBtnSecondRow($event.currentTarget)">Cat</a>
        </div>
        <div class="booking-steps__wrap-upper-btns-wrap">
          <a class="booking-steps__btn js-booking-steps__btn-second-row" data-name="dog" href="javascript:;" @click="activeBtnSecondRow($event.currentTarget)">Dog</a>
        </div>
        <div class="booking-steps__wrap-upper-btns-wrap">
          <a class="booking-steps__btn js-booking-steps__btn-second-row" data-name="other" :class="{ 'is-active':  contentVisibleSecond}" ref="accBtn" href="javascript:;" @click="activeBtnSecondRow($event.currentTarget);showDropdownSecond()">Other</a>
        </div>
      </div>
      <div class="booking-steps__wrap-upper-btns-block-hidden" v-if="contentVisibleSecond">
        <span class="val-error js-date-error-textarea-pets">This field is required</span>
        <label for="booking-address-textarea" class="booking-label">Other additional pet info <span>*</span></label>
        <textarea id="booking-address-textarea" @keyup="addressInfo.petsMessage.innerText = $event.target.value" :value="addressInfo ? addressInfo.petsMessage.innerText : ''" class="booking-steps__textarea js-second-row-message" placeholder="Write..."></textarea>
      </div>
    </div>
    <div class="booking-steps__wrap-upper-btns-block">
      <div class="booking-steps__wrap-upper-btns-block-shown">
        <label for="booking-address-textarea" class="booking-label">Special notes or instructions (optional)</label>
        <textarea id="booking-address-textarea" @keyup="addressInfo.instructions.innerText = $event.target.value" :value="addressInfo ? addressInfo.instructions.innerText : ''" class="booking-steps__textarea js-instructions-message" placeholder="Write..."></textarea>
      </div>
    </div>
    <div class="popup popup__successfull js-successfull-popup">
      <div class="popup-wrap">
        <p class="popup-desc">You have successfully submitted an email. You will be notified when your area becomes
          available.</p>
      </div>
    </div>
  </div><!-- .booking-location -->
</template>

<script>
import Global from '../../../js/shared/global';
import {mapGetters} from 'vuex';
import locationSearch from '../../../js/site/locationSearch';
import lottieWeb from 'lottie-web';

export default {
  beforeMount() {
    this.addressInfo = Global.readCookie('addressInfo');
    this.address = Global.readCookie('address');
    console.log('address: ', this.address);
  },
  props: ['asyncDone'],
  data() {
    return {
      address: '',
      apartment: '',
      contentVisible: false,
      contentVisibleSecond: false,
      contentVisibleThird: false,
      addressInfo: {},
      locationObj: {},
      displayLocation: false,
      imagesPath: process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/1.png'
    };
  },
  methods: {
    goToFirstStep() {
      this.$store.dispatch('setStepCount', 1);
      this.$store.dispatch('setCurrentStep', 'BlockStepLocation');
      const firstStem = document.getElementById('BlockStepLocation');
      firstStem.style.display = 'block';
      this.$store.dispatch('setNextStep', 'BlockStepOptions');
      this.$store.dispatch('setPreviousStep', null);
    },
    showDropdown() {
      this.refreshAddress(this.address);
      this.contentVisible = !this.contentVisible;
    },
    showDropdownSecond() {
      this.refreshAddress(this.address);
      this.contentVisibleSecond = !this.contentVisibleSecond;
    },
    showDropdownThird() {
      this.refreshAddress(this.address);
      this.contentVisibleThird = !this.contentVisibleThird;
    },
    activeBtnFirstRow(ele) {
      const addressObj = Global.readCookie('address');
      addressObj.apartment = document.querySelector('#address2').value;
      this.refreshAddress(addressObj);
      Global.setCookie('address', addressObj);
      const buttons = document.querySelectorAll('.js-booking-steps__btn-first-row');
      this.contentVisible = false;
      this.contentVisibleThird = false;
      if (!buttons) {
        return;
      }
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('is-active');
      }
      ele.classList.add('is-active');
      const error = ele.parentElement.parentElement.parentElement.querySelector('.js-date-error');
      if (error) {
        error.style.display = 'none';
      }
    },
    activeBtnSecondRow(ele) {
      this.refreshAddress(this.address);
      const buttons = document.querySelectorAll('.js-booking-steps__btn-second-row');
      this.contentVisibleSecond = false;
      if (!buttons) {
        return;
      }
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('is-active');
      }
      ele.classList.add('is-active');
      const error = ele.parentElement.parentElement.parentElement.querySelector('.js-date-error');
      if (error) {
        error.style.display = 'none';
      }
    },
    refreshAddress(address) {
      this.address = address;
    },
    updateApartment(ele) {
      this.apartment = ele.value;
      if (this.address) {
        const addressObj = Global.readCookie('address');
        addressObj.apartment = this.apartment;
        Global.setCookie('address', addressObj);
      }

    },
    setZip(ele) {
      const addressObj = Global.readCookie('address');
      addressObj.postal_code = ele.value;
      this.address = addressObj;
      Global.setCookie('address', addressObj);
    },
    getData() {
      // all inputs form location
      const inputs = document.querySelectorAll('.js-booking-input');
      for (let i = 0; i < inputs.length; i++) {
        const error = inputs[i].parentElement.querySelector('.js-custom-step-error');
        // if there is error message create error element
        if (inputs[i].validationMessage !== '' && error === null) {
          const error = document.createElement('span');
          error.classList.add('js-custom-step-error');
          error.classList.add('custom-step-error');
          error.innerText = inputs[i].validationMessage;
          inputs[i].parentElement.appendChild(error);
        }

        if (inputs[i].validationMessage === '') {
          if (error) {
            error.remove();
          }
        }
      }
    },
    animation() {
      setTimeout(() => {
        const animContainer = document.getElementsByClassName('anim-container--01');
        let animation;
        animContainer.forEach(function(el) {
          animation = process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/Icon1.json';
          const anim = lottieWeb.loadAnimation({
            container: el,
            animType: 'svg',
            loop: true,
            autoplay: true,
            path: animation,
            renderer: 'svg',
            rendererSettings: {
              progressiveLoad: true,
            },
          });
          anim.play();
        });
      }, 500);
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentStep',
      'getTitle',
    ]),
  },
  mounted() {
    if (!this.addressInfo) {
      return;
    }
    // prefill options
    // just radios, other option are prefilled in html structure

    // get in radios
    const getInOptions = document.querySelectorAll('.js-booking-steps__btn-first-row');
    for (let i = 0; i < getInOptions.length; i++) {
      if (getInOptions[i].innerText === this.addressInfo.getIn.innerText) {
        getInOptions[i].click();
      }
    }

    // pets radios
    const petsOptions = document.querySelectorAll('.js-booking-steps__btn-second-row');
    for (let i = 0; i < petsOptions.length; i++) {
      if (petsOptions[i].innerText === this.addressInfo.pets.innerText) {
        petsOptions[i].click();
      }
    }

    this.animation();
    // const entries = performance.getEntriesByType('navigation');
    // const entryType = entries.map(nav => nav.type);
    // // if is in array (use === if is not in array)
    // if (entryType.indexOf('back_forward') !== -1) {
    //   this.displayLocation = false;
    //   this.$store.dispatch('setCurrentStep', 'BlockStepAddress');
    //   this.$store.dispatch('setPreviousStep', 'BlockStepTime');
    // }

    const isBack = Global.readCookie('isBack');
    if (isBack) {
      if (isBack === true) {
        this.displayLocation = false;
        this.$store.dispatch('setCurrentStep', 'BlockStepAddress');
        this.$store.dispatch('setPreviousStep', 'BlockStepTime');
        Global.setCookie('isBack', false);
      }
    }


    locationSearch.initAutocompleteWidget();
  }
};
</script>

<style lang="scss" scoped>

.booking-address {

  .booking-label {
    font-size: 20px;
    letter-spacing: 4px;

    span {
      color: $tree-poppy;
    }

    @include mq($lg) {
      margin-bottom: 15px;
    }

    @include mq($md) {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }

  .booking-steps__btn {
    min-width: auto;
    max-width: initial;
    width: 100%;
  }

  .booking-steps__wrap-upper-btns {
    justify-content: space-between;
    margin: 0;
  }

  .booking-steps__wrap-upper-btns-wrap {
    margin: 0;
    max-width: 24%;
    width: 100%;

    @include mq($lg) {
      max-width: 49%;
      margin-top: 15px;
    }
  }
}

.booking-steps__wrap-block {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 53px;

  @include mq($md) {
    margin-top: 35px;
  }
}

.booking-address__form-wrap-half {
  max-width: 74.5%;
  width: 100%;
  margin-top: 15px;

  @include mq($lg) {
    max-width: 59%;
  }

  @include mq($xs-phone) {
    max-width: 100%;
  }
}

.booking-address__form-wrap-half--small {
  max-width: 23.5%;

  @include mq($lg) {
    max-width: 39%;
  }

  @include mq($xs-phone) {
    max-width: 100%;
  }
}

.booking-steps__wrap-upper-btns-block {
  margin-top: 60px;

  @include mq($xl) {
    margin-top: 35px;
  }
}

.booking-steps__wrap-upper-btns-block-hidden {
  margin-top: 60px;

  @include mq($xl) {
    margin-top: 35px;
  }
}

.is-active {
  border: 3px solid $tree-poppy;
  background-color: $white;
  color: $tree-poppy;
}

.checkbox-link {
  margin-left: 25px;
  margin-top: 10px;
  display: flex;
  width: fit-content;

  @include mq($lg) {
    margin-left: 20px;
    font-size: 14px;
  }
}

.booking-input {

  //&.filled {
  //  pointer-events: none;
  //  opacity: 0.5;
  //}
}

.booking-location__form-holder {
  max-width: 100%;
  width: 100%;
}

.booking-location__form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 35px;

  &:first-child {
    margin-top: 0;
  }

  @include mq($xs-phone) {
    margin-top: 0;
  }
}

.booking-location__form-wrap-full {
  max-width: 66%;
  width: 100%;
  margin-top: 30px;

  @include mq($md) {
    max-width: 48%;
  }

  @include mq($md) {
    max-width: 100%;
    margin-top: 10px;
  }
}

.booking-location__form-wrap-half {
  max-width: 32%;
  width: 100%;
  margin-top: 30px;

  @include mq($md) {
    max-width: 48%;
  }

  @include mq($xs-phone) {
    max-width: 100%;
    margin-top: 20px;
  }
}

.booking-location__form-input {
  position: relative;
}

.booking-location__form-input-ico {
  position: absolute;
  top: 50%;
  right: 27px;
  transform: translateY(-50%);
  font-size: 20px;
  height: 20px;
  color: $mine-shaft;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
}

.booking-location__image {
  max-width: 500px;
  width: 100%;
  transform: translate(-4px, 47px);
  margin: 0 auto;

  @include mq($xl) {
    max-width: 40%;
    margin-top: 50px;
    transform: translate(0);
  }

  @include mq($lg) {
    max-width: 300px;
  }
}

.booking-steps__wrap {
  @include mq($lg) {
    max-width: 100%;
  }
}
</style>
